import { render, staticRenderFns } from "./compare.vue?vue&type=template&id=cdd2eaa0&scoped=true&"
import script from "./compare.vue?vue&type=script&lang=js&"
export * from "./compare.vue?vue&type=script&lang=js&"
import style0 from "./compare.vue?vue&type=style&index=0&id=cdd2eaa0&scoped=true&lang=less&"
import style1 from "./compare.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cdd2eaa0",
  null
  
)

export default component.exports